import Sum from "./Sum";
import LCS from "./LCS";
import SCS from "./SCS";
import Coin from "./Coin";
import Kadane from "./Kadane";
import LIS from "./LIS";
import Multiply from "./Multiply";
import Freq from "./Freq";
import EditDistance from "./EditDistance";
import ArrayRotation from "./ArrayRotation";
import NonRepeat from "./NonRepeat";
import Fibonacci from "./Fibonacci";
import CommonElement from "./CommonElement";
import EggDropping from "./EggDropping";
import Partition from "./Partition";
import Knapsack from "./Knapsack";
import MaximumProduct from "./MaximumProduct";
import RodCutting from "./RodCutting";
import WordBreak from "./WordBreak";
import Sorting from "./Sorting";
import DiceThrow from "./DiceThrow";
import DiceThrowProbability from "./DiceThrowProbability";
import BooleanParenthesization from "./BooleanParenthesization";
import OptimalStrategy from "./OptimalStrategy";
import Search from "./Search";
import Segment from "./Segment";
import ShortestPath from "./ShortestPath";
//
import React, { Component } from "react";

//https://stackoverflow.com/questions/35352638/how-to-get-parameter-value-from-query-string
//http://localhost:3000/?page=lcs

class App extends Component {
	render() {
		let page = new URLSearchParams(window.location.search).get("page");
		// console.log("page = " + page);

		var p = <Coin />; //oldest

		if (page == "coin") {
			p = <Coin />;
		} else if (page == "lcs") {
			//Longest Common Subsequence (LCS)
			p = <LCS />;
		} else if (page == "sum") {
			//Subarray with given sum
			p = <Sum />;
		} else if (page == "kadane") {
			//Kadane's algorithm
			p = <Kadane />;
		} else if (page == "lis") {
			//Longest Increasing Subsequence (LIS)
			p = <LIS />;
		} else if (page == "multiply") {
			p = <Multiply />;
		} else if (page == "freq") {
			//Most Frequently Occurring Item
			p = <Freq />;
		} else if (page == "editdistance") {
			p = <EditDistance />;
		} else if (page == "scs") {
			//Shortest Common Supersequence (SCS)
			p = <SCS />;
		} else if (page == "arrayrotation") {
			//ArrayRotation
			p = <ArrayRotation />;
		} else if (page == "nonrepeat") {
			//ArrayRotation
			p = <NonRepeat />;
		} else if (page == "fibonacci") {
			p = <Fibonacci />;
		} else if (page == "commonelement") {
			p = <CommonElement />;
		} else if (page == "eggdrop") {
			p = <EggDropping />;
		} else if (page == "partition") {
			p = <Partition />;
		} else if (page == "knapsack") {
			p = <Knapsack />;
		} else if (page == "maximumproduct") {
			p = <MaximumProduct />;
		} else if (page == "rodcutting") {
			p = <RodCutting />;
		} else if (page == "wordbreak") {
			p = <WordBreak />;
		} else if (page == "sorting") {
			p = <Sorting />;
		} else if (page == "dicethrow") {
			p = <DiceThrow />;
		} else if (page == "dicethrow_probability") {
			p = <DiceThrowProbability />;
		} else if (page == "boolean_parenthesization") {
			p = <BooleanParenthesization />;
		} else if (page == "optimal_strategy") {
			p = <OptimalStrategy />;
		} else if (page == "search") {
			p = <Search />;
		} else if (page == "segment") {
			p = <Segment />;
		} else if (page == "shortestpath") {
			p = <ShortestPath />;
		} 
		//24
		return p;
	}
}

export default App;

//NOT WORK ===============

// https://p-library.com/p/tool/react1/sum
// https://p-library.com/p/tool/react1/index.html
// https://p-library.com/p/tool/react1/#/sum
// https://p-library.com/p/tool/react1/#/coin
// https://p-library.com/p/tool/react1/coin

// import { Link, Route, Switch } from "react-router-dom";
//https://codesandbox.io/s/nn8x24vm60?file=/index.js:27-135
//  "homepage": ".",
//   "homepage": ".",

// class App extends Component {
//   render() {
//     return (
//       <div>
//         <nav className="navbar navbar">
//           <ul className="nav">
//             <li>
//               <Link to="/">Home</Link>
//             </li>
//             <li>
//               <Link to="/coin">Coin</Link>
//             </li>
//             <li>
//               <Link to="/sum">Sum</Link>
//             </li>
//           </ul>
//         </nav>
//         <Switch>
//           <Route path="/coin" component={Coin} />
//           <Route path="/sum" component={Sum} />
//           <Route exact path="/lcs" component={LCS} />
//           <Route exact path="/" component={Coin} />
//         </Switch>
//       </div>
//     );
//   }
// }

// //Home component
// const Home = props => (
//   <div>
//     <h2>Home {console.log(props)}</h2>
//   </div>
// );

// const App = () => (
//     <main>
//       <Switch>
//         <Route exact path='/' component={Coin}/>
//         <Route path='/coin' component={Coin}/>
//         <Route exact path='/lcs' component={LCS}/>
//         <Route path='/sum' component={Sum}/>
//       </Switch>
//     </main>
//   )
